"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var elements_1 = require("../elements");
var OldwayNewway_1 = require("../../defaults/OldwayNewway");
var Icon_1 = __importDefault(require("../elements/Icon"));
var _helpers_1 = require("../../helpers");
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var OldwayNewwayContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: ", ";\n"], ["\n  background: ", ";\n"])), function (_a) {
    var dark = _a.dark, theme = _a.theme;
    return (dark ? theme.bgDark : theme.bgLight);
});
var OldwayNewwayContainerItem = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  border: ", ";\n  padding: ", ";\n"], ["\n  border: ",
    ";\n  padding: ", ";\n"])), function (_a) {
    var dark = _a.dark, theme = _a.theme, border = _a.border;
    return border ? "1px solid " + (dark ? theme.bgLight : theme.bgDark) : 'none';
}, function (_a) {
    var border = _a.border;
    return (border ? '20px' : '0');
});
var OldwayNewwayItem = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  i {\n    margin: 0 10px 0 0;\n  }\n"], ["\n  display: flex;\n  i {\n    margin: 0 10px 0 0;\n  }\n"])));
var OldwayNewway = function (_a) {
    var sectionConfig = _a.sectionConfig, oldway = _a.oldway, newway = _a.newway, _b = _a.border, border = _b === void 0 ? false : _b, dark = _a.dark;
    var mergedSectionConfig = _helpers_1.merge(OldwayNewway_1.defaultSectionConfig, sectionConfig);
    var isDark = dark || (mergedSectionConfig === null || mergedSectionConfig === void 0 ? void 0 : mergedSectionConfig.dark);
    return (react_1.default.createElement(elements_1.Section, __assign({}, mergedSectionConfig, { dark: isDark }),
        react_1.default.createElement(OldwayNewwayContainer, { className: "columns is-multiline", dark: isDark },
            react_1.default.createElement("div", { className: "column is-12-mobile is-6-desktop" },
                react_1.default.createElement(OldwayNewwayContainerItem, { dark: isDark, border: border },
                    react_1.default.createElement(elements_1.Text, __assign({}, OldwayNewway_1.defaultItemTitleConfig, oldway.titleConfig, { dark: isDark })),
                    oldway.items.map(function (item, i) { return (react_1.default.createElement(OldwayNewwayItem, { key: i, dark: isDark },
                        item.iconConfig && react_1.default.createElement(Icon_1.default, __assign({ dark: isDark }, item.iconConfig)),
                        react_1.default.createElement(elements_1.Text, __assign({}, OldwayNewway_1.defaultItemDescriptionConfig, item.descriptionConfig, { dark: isDark })))); }))),
            react_1.default.createElement("div", { className: "column is-12-mobile is-6-desktop" },
                react_1.default.createElement(OldwayNewwayContainerItem, { dark: isDark, border: border },
                    react_1.default.createElement(elements_1.Text, __assign({}, OldwayNewway_1.defaultItemTitleConfig, newway.titleConfig, { dark: isDark })),
                    newway.items.map(function (item, i) { return (react_1.default.createElement(OldwayNewwayItem, { key: i, dark: isDark },
                        item.iconConfig && react_1.default.createElement(Icon_1.default, __assign({}, item.iconConfig)),
                        react_1.default.createElement(elements_1.Text, __assign({}, OldwayNewway_1.defaultItemDescriptionConfig, item.descriptionConfig, { dark: isDark })))); }))))));
};
exports.default = OldwayNewway;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=OldwayNewway.js.map